var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDealerBulletinsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 98,
    height: 89.548,
    viewBox: "0 0 98 89.548",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "dealer_bulletins") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "10l8qqlhoa",
    x: 0,
    y: 4.452,
    width: 98,
    height: 85.097,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "icon base"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(9)",
    style: {
      fill: "none",
      opacity: 0.1
    },
    d: "M0 0h88v88H0z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#10l8qqlhoa)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "list-ul-solid",
    d: "M23.742 63.484A7.742 7.742 0 1 0 16 55.742a7.742 7.742 0 0 0 7.742 7.742zm20.645-12.9a5.161 5.161 0 0 0 0 10.323h46.452a5.161 5.161 0 1 0 0-10.323zm0 25.806a5.161 5.161 0 1 0 0 10.323h46.452a5.161 5.161 0 1 0 0-10.323zm0 25.806a5.161 5.161 0 0 0 0 10.323h46.452a5.161 5.161 0 1 0 0-10.323zM23.742 115.1A7.742 7.742 0 1 0 16 107.355a7.742 7.742 0 0 0 7.742 7.742zm7.742-33.548a7.742 7.742 0 1 0-7.742 7.742 7.742 7.742 0 0 0 7.742-7.746z",
    transform: "translate(-7 -37.55)",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDealerBulletinsIcon);
export default __webpack_public_path__ + "static/media/dealer_bulletins_icon.06eea9edcd5c23b7b7c018bc00e776a5.svg";
export { ForwardRef as ReactComponent };